import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class Whmis2015Service {

constructor(private http: HttpClient) { }

  baseUrl = environment.apiUrl;
  
getHealthHazardClass() {
  let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/json');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json');
    }
  return this.http.get(this.baseUrl + 'whmis2015/HealthHazard', {headers: httpHeaders});
}

getPhysicalHazardClass() {
  let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/json');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json');
    }
  return this.http.get(this.baseUrl + 'whmis2015/PhysicalHazard', {headers: httpHeaders});
}

getHazardCategory() {
  let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/json');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json');
    }
  return this.http.get(this.baseUrl + `whmis2015/HazardCategorys`, {headers: httpHeaders});
}

getHealthClass() {
  let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/json');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json');
    }
  return this.http.get(this.baseUrl + 'whmis2015/healthClasses', {headers: httpHeaders});
}

getPhysicalClass() {
  let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/json');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json');
    }
  return this.http.get(this.baseUrl + 'whmis2015/PhysicalClasses', {headers: httpHeaders});
}

getPhysicalStates() {
  let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/json');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json');
    }
  return this.http.get(this.baseUrl + `whmis2015/PhysicalStates`, {headers: httpHeaders});
}

getExemptionClass() {
  let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/json');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json');
    }
  return this.http.get(this.baseUrl + `whmis2015/ExemptionClass`, {headers: httpHeaders});
}

getSDSOrigin() {
  let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/json');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json');
    }
  return this.http.get(this.baseUrl + `whmis2015/SDSOrigin`, {headers: httpHeaders});
}

getAcuteHealthRoutes() {
  let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/json');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json');
    }
  return this.http.get(this.baseUrl + 'whmis2015/acutehealthRoutes', {headers: httpHeaders});
}

getSkinIrrCorrHealthRoutes() {
  let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/json');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json');
    }
  return this.http.get(this.baseUrl + 'whmis2015/skinCorrhealthRoutes', {headers: httpHeaders});
}

getPhysicalRoutes() {
  let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/json');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json');
    }
  return this.http.get(this.baseUrl + 'whmis2015/physicalRoutes', {headers: httpHeaders});
}

getHealthCategories() {
  let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/json');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json');
    }
  return this.http.get(this.baseUrl + 'whmis2015/healthHazardCategorys', {headers: httpHeaders});
}

getPhysicalCategories() {
  let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/json');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json');
    }
  return this.http.get(this.baseUrl + 'whmis2015/physicalHazardCategorys', {headers: httpHeaders});
}

getTransportHazardClasses() {
  let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/json');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json');
    }
  return this.http.get(this.baseUrl + 'whmis2015/transportHazardClasses', {headers: httpHeaders});
}

getAllIArcValues() {
  let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/json');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json');
    }
  return this.http.get(this.baseUrl + 'whmis2015/iarcValues', {headers: httpHeaders});
}

getAllAcgihValues() {
  let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/json');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json');
    }
  return this.http.get(this.baseUrl + 'whmis2015/acgihValues', {headers: httpHeaders});
}

getAllNFPARatingsHealthValues() {
  let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/json');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json');
    }
  return this.http.get(this.baseUrl + 'whmis2015/nfpaRatingsHealth', {headers: httpHeaders});
}

getAllNfpaRatingsFlammabilityValues() {
  let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/json');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json');
    }
  return this.http.get(this.baseUrl + 'whmis2015/nfpaRatingsFlammability', {headers: httpHeaders});
}

getAllNfpaRatingsInstability() {
  let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/json');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json');
    }
  return this.http.get(this.baseUrl + 'whmis2015/nfpaRatingsInstability', {headers: httpHeaders});
}

getAllNfpaRatingsSpecific() {
  let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/json');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json');
    }
  return this.http.get(this.baseUrl + 'whmis2015/nfpaRatingsSpecific', {headers: httpHeaders});
}

getAllHmisRatingsHealth() {
  let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/json');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json');
    }
  return this.http.get(this.baseUrl + 'whmis2015/hmisRatingshealth', {headers: httpHeaders});
}

getAllHmisRatingsChronic() {
  let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/json');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json');
    }
  return this.http.get(this.baseUrl + 'whmis2015/hmisRatingsChronic', {headers: httpHeaders});
}

getAllHmisRatingsFlammability() {
  let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/json');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json');
    }
  return this.http.get(this.baseUrl + 'whmis2015/hmisRatingsFlammability', {headers: httpHeaders});
}

getAllHmisRatingsReactivity() {
  let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/json');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json');
    }
  return this.http.get(this.baseUrl + 'whmis2015/hmisRatingsReactivity', {headers: httpHeaders});
}

getPictograms() {
  let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/json');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json');
    }
  return this.http.get(this.baseUrl + 'whmis2015/pictograms', {headers: httpHeaders});
}
}
